import { z } from 'zod';

import { DeliveryLogChannelSchema, DeliveryLogStatusSchema } from './enums';

// ============================================================================
// Delivery Logs — GET /api/v1/admin/delivery-logs
// ============================================================================

export const ListDeliveryLogsQuerySchema = z.object({
  channel: DeliveryLogChannelSchema.optional(),
  status: DeliveryLogStatusSchema.optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(100).default(20),
});

export type ListDeliveryLogsQuery = z.infer<typeof ListDeliveryLogsQuerySchema>;

export const DeliveryLogItemSchema = z.object({
  id: z.string().uuid(),
  channel: DeliveryLogChannelSchema,
  recipient: z.string(),
  templateId: z.string().nullable(),
  templateName: z.string().nullable(),
  subject: z.string().nullable(),
  status: DeliveryLogStatusSchema,
  sentAt: z.string().datetime().nullable(),
  deliveredAt: z.string().datetime().nullable(),
  errorMessage: z.string().nullable(),
  attempts: z.number().int(),
  createdAt: z.string().datetime(),
});

export type DeliveryLogItem = z.infer<typeof DeliveryLogItemSchema>;

export const ListDeliveryLogsResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(DeliveryLogItemSchema),
  meta: z.object({
    page: z.number().int(),
    limit: z.number().int(),
    total: z.number().int(),
    totalPages: z.number().int(),
  }),
});

export type ListDeliveryLogsResponse = z.infer<typeof ListDeliveryLogsResponseSchema>;
